type Props = { title?: string };
export default function SpaceBadge({ title }: Props) {
  return (
    <div className="flex items-center rounded-md py-1 pl-1.5 pr-2 gap-1.5 cursor-pointer text-sm flex bg-[#333F48] text-white font-semibold w-fit">
      <div className="w-1 h-1 bg-white rounded-full"></div>
      {title}
    </div>
  );
}
